// utils/formatCurrency.ts

export const formatCurrency = (
  value?: number | string | null
): string => {

  const amount = Number(value || 0);

  // =====================================================
  // 🔹 Corrección floating point JS
  // =====================================================

  const rounded =
    Math.round((amount + Number.EPSILON) * 100) / 100;

  return rounded.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * 🔢 Formatea cantidades/costos unitarios con 4 decimales y separador de
 * miles (ej. 1,234.5678). Se usa en columnas donde se necesita más
 * precisión que el formato de moneda estándar (2 decimales).
 */
export const formatQuantity = (
  value?: number | string | null
): string => {
  const amount = Number(value || 0);

  const rounded =
    Math.round((amount + Number.EPSILON) * 10000) / 10000;

  return rounded.toLocaleString("en-US", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
};